import { attr, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const PageType = ApplicationRecord.extend({
  static: {
    jsonapiType: 'page_types',
  },
  attrs: {
    name: attr(),
    description: attr(),
    pageOptionTypes: hasMany(),
  },
})

export default PageType
